import { useEffect } from "react";
import { formRules, roleNames } from "../../constant";
import { Modal, Typography, Form, Input, Checkbox, Space } from "antd";
import PrimaryButton from "../Forms/PrimaryButton";
import { useGlobalModal } from "../../context/SuccessModalProvider";

const { Title, Text } = Typography;

const DEFAULT_ROLES = Object.entries(roleNames).map(([value, label]) => ({
  value: Number(value),
  label,
}));

const NewAnnouncement = ({
  isOpen,
  closeModal,
  data,
  onConfirm,
  loading = false,
  roleOptions = DEFAULT_ROLES,
  title = "Add Announcement",
  btnText = "Save and Proceed",
}) => {
  const [form] = Form.useForm();
  const { showPopup } = useGlobalModal();

  useEffect(() => {
    if (isOpen && data) {
      form.setFieldsValue({
        announcement_title: data.announcement_title ?? "",
        announcement_desc: data.announcement_desc ?? "",
        announcement_roles: data.announcement_roles
          ? data.announcement_roles.split(",").map(Number)
          : [],
      });
    }
  }, [isOpen, data, form]);

  const handleFinish = async (values) => {
    /**
     * values = {
     *   title: string,
     *   description: string,
     *   roles: number[]
     * }
     */

    if (!values.announcement_desc?.trim()) {
      return showPopup({
        title: null,
        content: (
          <span className="custom-modal-title">Please add a description.</span>
        ),
        onOk: () => console.log("Confirmed!"),
        className: "custom-success-modal",
      });
    }

    if (!values.announcement_roles?.length) {
      return showPopup({
        title: null,
        content: (
          <span className="custom-modal-title">
            Please select at least one role.
          </span>
        ),
        onOk: () => console.log("Confirmed!"),
        className: "custom-success-modal",
      });
    }

    if (typeof onConfirm === "function") {
      const res = await onConfirm(
        {
          ...values,
          announcement_desc: values.announcement_desc?.trim(),
        },
        data,
      );
      if (res) {
        form.resetFields();
        closeModal();
      }
    }
  };

  return (
    <Modal
      open={!!isOpen}
      centered
      title={
        <Title level={2} className="font-abhaya !mb-0">
          {title}
        </Title>
      }
      onCancel={closeModal}
      destroyOnHidden
      width={400}
      footer={null}
      className="form-css-5"
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        {data?.full_name && (
          <Text className="block text-base mb-3">
            Creating announcement for <strong>{data.full_name}</strong>
          </Text>
        )}

        {/* Title */}
        <Form.Item
          label="Title"
          name="announcement_title"
          rules={formRules.required}
        >
          <Input placeholder="Enter title" className="h-10" />
        </Form.Item>

        {/* Description */}
        <Form.Item
          label="Description"
          name="announcement_desc"
          rules={formRules.required}
        >
          <Input.TextArea rows={4} placeholder="Enter description" />
        </Form.Item>

        {/* Roles (Multi-select) */}
        <Form.Item label="Users" name="announcement_roles" required>
          <Checkbox.Group style={{ width: "100%" }}>
            <Space direction="vertical">
              {roleOptions.map((role) => (
                <Checkbox key={role.value} value={role.value}>
                  {role.label}
                </Checkbox>
              ))}
            </Space>
          </Checkbox.Group>
        </Form.Item>

        {/* Footer */}
        <div className="w-full flex justify-center mt-4">
          <PrimaryButton
            text={btnText}
            type="submit"
            htmlType="submit"
            loading={loading}
            className="me-[30px]"
          />
        </div>
      </Form>
    </Modal>
  );
};

export default NewAnnouncement;
